import { FaDraftingCompass, FaHardHat, FaPencilRuler } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';
import thumb1 from '../../assets/img/approch1.jpg';
import thumb2 from '../../assets/img/approch2.jpg';
import thumb3 from '../../assets/img/approch3.jpg';

const approchData = [
    {
        id: uuidv4(),
        thumb: thumb1,
        icon: <FaDraftingCompass />,
        heading: 'Viziunea Noastră',
        text: 'Să devenim liderul pieței în furnizarea de servicii de construcții și renovări de înaltă calitate în București și împrejurimi',
        btnText: 'Citește Mai Mult',
        pageLink: '/despre-noi',
    },

    {
        id: uuidv4(),
        thumb: thumb2,
        icon: <FaPencilRuler />,
        heading: 'Misiunea Noastră',
        text: 'Oferim soluții eficiente și moderne, depășind așteptările clienților prin profesionalism, calitate și dedicare',
        btnText: 'Citește Mai Mult',
        pageLink: '/despre-noi',
    },

    {
        id: uuidv4(),
        thumb: thumb3,
        icon: <FaHardHat />,
        heading: 'Abordarea Noastră',
        text: 'Folosim muncitori calificați, materiale premium și respectăm standardele ISO pentru rezultate durabile',
        btnText: 'Citește Mai Mult',
        pageLink: '/despre-noi',
    },
];

export default approchData;
